<script>
  import { t } from "../../../core";

  import type { ICurrentSchedule } from "./SchedulePanel.svelte";

  export let currentSchedule: ICurrentSchedule;

  const row = currentSchedule.rows[0];

  const weeks: number[] =
    currentSchedule.earliestWeek && currentSchedule.latestWeek
      ? getRangeArray(
          currentSchedule.earliestWeek.index,
          currentSchedule.latestWeek.index
        )
      : [];

  function getRangeArray(start: number, end: number): number[] {
    return Array(end - start + 1)
      .fill(null)
      .map((_, idx) => start + idx);
  }
</script>

<div class="current-schedule">
  <div class="current-schedule__weeks">
    <div class="current-schedule__week">
      {t("General.Week.Title")}
      {currentSchedule.earliestWeek?.number}
    </div>
    <div class="current-schedule__week">
      {t("General.Week.Title")}
      {currentSchedule.latestWeek?.number}
    </div>
  </div>

  <div class="current-schedule__data">
    <div class="current-schedule__row">
      {#each weeks as week}
        <div
          class="current-schedule__item"
          class:expected={row.expectedWeekIndexes.includes(week)}
        />
      {/each}
    </div>
    <div class="current-schedule__row">
      {#each weeks as week}
        <div
          class="current-schedule__item"
          class:delay={row.delayWeekIndexes.includes(week)}
          class:real={row.realWeekIndexes.includes(week)}
        />
      {/each}
    </div>
    <div
      style="left: {(100 / weeks.length) *
        (currentSchedule.currentWeek?.index -
          currentSchedule.earliestWeek?.index)}%"
      class="current-schedule__current-week"
    />
  </div>
</div>

<style lang="scss">
  .current-schedule {
    &__weeks {
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      margin-bottom: 10px;
    }

    &__data {
      position: relative;
      margin-bottom: 18px;
    }

    &__row {
      display: flex;
      max-width: 100%;
      margin-bottom: 6px;
    }

    &__item {
      flex: 1;
      height: 8px;
    }

    &__current-week {
      position: absolute;
      height: 37px;
      width: 1px;
      background: #db8700;
      top: -6px;
    }
  }

  .expected {
    background-color: #a7a7a7;
  }
  .delay {
    background-color: #942810;
  }
  .real {
    background-color: #002c64;
  }
</style>
